import { Link } from 'react-router-dom';
import { articles } from '@/mocks/seo-content';

const previewArticles = articles.slice(1);

export default function ArticlesGrid() {
  return (
    <section className="px-4 md:px-6 py-10 md:py-14 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-10">
          <span className="inline-block px-4 py-1.5 rounded-full bg-primary-100 text-primary-700 text-xs font-semibold mb-4 whitespace-nowrap">
            SEO Guides & Resources
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            Sugargoo Spreadsheet Knowledge Center
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            In-depth guides covering every aspect of using your Sugargoo Spreadsheet for smarter shopping, better deals, and informed decisions.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {previewArticles.map((article) => (
            <article
              key={article.slug}
              className="group flex flex-col bg-background-50 rounded-lg border border-background-200/70 overflow-hidden hover:border-primary-200 transition-colors"
            >
              <Link
                to={`/article/${article.slug}`}
                className="block w-full aspect-[16/10] overflow-hidden"
              >
                <img
                  src={article.imageUrl}
                  alt={article.title}
                  title={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                />
              </Link>

              <div className="flex flex-col flex-1 p-5">
                <div className="flex items-center gap-3 mb-3 text-xs text-foreground-400">
                  <span className="whitespace-nowrap">
                    <i className="ri-calendar-line mr-1"></i>
                    {article.datePublished}
                  </span>
                  <span className="whitespace-nowrap">
                    <i className="ri-time-line mr-1"></i>
                    {article.readTime}
                  </span>
                </div>

                <Link
                  to={`/article/${article.slug}`}
                  className="block mb-2"
                >
                  <h3 className="font-heading text-base font-semibold text-foreground-950 group-hover:text-primary-600 transition-colors leading-snug line-clamp-2">
                    {article.title}
                  </h3>
                </Link>

                <p className="text-sm text-foreground-600 leading-relaxed mb-4 line-clamp-2 flex-1">
                  {article.excerpt}
                </p>

                <Link
                  to={`/article/${article.slug}`}
                  className="inline-flex items-center gap-1.5 text-sm font-semibold text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap mt-auto"
                >
                  Read Article
                  <i className="ri-arrow-right-line text-sm"></i>
                </Link>
              </div>
            </article>
          ))}
        </div>

        <div className="text-center mt-8">
          <Link
            to="/article/sugargoo-spreadsheet-complete-guide"
            className="inline-flex items-center gap-2 px-6 py-3 text-sm font-semibold rounded-md bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors whitespace-nowrap"
          >
            <i className="ri-book-open-line"></i>
            View Complete Guide
          </Link>
        </div>
      </div>
    </section>
  );
}